import './footer.css'

function Footer() {
  return (
      <div className="footer-container">
        <p>Erica Nwoga © {new Date().getFullYear()} </p>
      </div>
  )
}

export default Footer
